import { Component } from '@angular/core';
import { UserTabNames } from '../users-detail/users-detail.component';

@Component({
	selector: 'app-user-detail-skeleton',
	imports: [],
	templateUrl: './user-detail-skeleton.component.html',
	styleUrl: './user-detail-skeleton.component.scss',
})
export class UserDetailSkeletonComponent {
	tabs = [UserTabNames.Info, UserTabNames.Policies, UserTabNames.Quotes, UserTabNames.PaymentMethods, /* UserTabNames.Referrals */];
}
